const ToggleSwitch = ({ label, value, onChange, icon, disabled = false }) => {
  return (
    <div className="input-toggle-container">
      {label && <label className="input-label">{label}</label>}
      <div className="input-wrapper toggle-wrapper">
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
          />
          <span className="slider round"></span>
        </label>
        {icon && <span className="input-icon">{icon}</span>}
      </div>
    </div>
  );
};

export default ToggleSwitch;